import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { StihlPollDTO, StihlPollUserDTO } from '../models/stihl-poll-dto';
import { ChangeOrderDTO } from '../models/change-order-dto';
import { Select2Data } from 'ng-select2-component';

@Injectable({
  providedIn: 'root'
})

export class PollService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlPoll/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<StihlPollDTO> {
    return this.http.get<StihlPollDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
  }

  public getPollUserFilled(idData: string, idPoll): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'GetPollUserFilled/' + idData + "/" + idPoll);
  }

  public getPollType(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetPollType');
  }

  public postPollUser(data: StihlPollUserDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "PostUserPoll", data);
  }

  downloadPollResult(idData, idPoll): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetPollResult/' + idData + "/" + idPoll;
    return this.http.get<Blob>(endpoint, requestOptions);
  }
}
